export default __webpack_public_path__ + "static/media/pic1.a92ada04.svg";